import { ELocalStorageKeys, ELoginMode } from '@/lib/enums';

import { Observable } from './observable';
import { webStorageUtil } from './webStorage.state.service';

class LoginStateService {
  readonly showCookiesOverlay = new Observable<boolean>(false);
  readonly loggingWithProofKey = new Observable<boolean>(false);
  readonly proofKey = new Observable<string>('');
  readonly otpToken = new Observable<string>('');
  readonly mode = new Observable<ELoginMode>(ELoginMode.PROVIDERS);
  readonly hasConsent = new Observable<boolean>(true);
  readonly shouldShowTermsAlert = new Observable<boolean>(false);
  readonly isTermsAlertShaking = new Observable<boolean>(false);
  readonly isLoginModalOpen = new Observable<boolean>(false);
  readonly isLoggingIn = new Observable<boolean>(false);
  readonly loginType = new Observable<ELoginMode | null>(null);
  // Seeded from storage, so declared with the anonymous value the server renders.
  readonly isLoggedIn = new Observable<boolean>(
    Boolean(webStorageUtil.get(ELocalStorageKeys.PLAYER_DATA)),
    { serverSnapshot: false }
  );
  readonly isOtpRedirectPending = new Observable<boolean>(false);
  readonly isOtpLoggingIn = new Observable<boolean>(false);
  readonly isConsentChecked = new Observable<boolean>(
    webStorageUtil.get(ELocalStorageKeys.USER_LOGIN_TERMS_CONSENT) === 'true',
    { serverSnapshot: false }
  );
  readonly loginError = new Observable<string | null>(null);

  clear = () => {
    this.showCookiesOverlay.set(false);
    this.loggingWithProofKey.set(false);
    this.proofKey.set('');
    this.otpToken.set('');
    this.mode.set(ELoginMode.PROVIDERS);
    this.hasConsent.set(true);
    this.shouldShowTermsAlert.set(false);
    this.isTermsAlertShaking.set(false);
    this.isLoginModalOpen.set(false);
    this.isLoggingIn.set(false);
    this.loginType.set(null);
    this.isLoggedIn.set(false);
    this.isOtpRedirectPending.set(false);
    this.isOtpLoggingIn.set(false);
    this.isConsentChecked.set(false);
    this.loginError.set(null);
  };
  setShowCookiesOverlay = (show: boolean) => this.showCookiesOverlay.set(show);
  setLoggingWithProofKey = (isLogginWithProofkey: boolean) =>
    this.loggingWithProofKey.set(isLogginWithProofkey);
  setProofKey = (key: string) => this.proofKey.set(key);
  setOtpToken = (token: string) => this.otpToken.set(token);
  setMode = (newMode: ELoginMode) => this.mode.set(newMode);
  setHasConsent = (consent: boolean) => this.hasConsent.set(consent);
  setShouldShowTermsAlert = (show: boolean) => this.shouldShowTermsAlert.set(show);
  setIsTermsAlertShaking = (shaking: boolean) => this.isTermsAlertShaking.set(shaking);
  setIsLoginModalOpen = (isOpen: boolean) => this.isLoginModalOpen.set(isOpen);
  setIsLoggingIn = (isLoggingIn: boolean) => this.isLoggingIn.set(isLoggingIn);
  setLoginType = (loginType: ELoginMode | null) => this.loginType.set(loginType);
  setIsLoggedIn = (isLoggedIn: boolean) => this.isLoggedIn.set(isLoggedIn);
  setIsOtpRedirectPending = (isPending: boolean) => this.isOtpRedirectPending.set(isPending);
  setIsOtpLoggingIn = (isLoggingIn: boolean) => this.isOtpLoggingIn.set(isLoggingIn);
  setIsConsentChecked = (isConsentChecked: boolean) => this.isConsentChecked.set(isConsentChecked);
  setLoginError = (error: string | null) => this.loginError.set(error);
}
export const loginStateService = new LoginStateService();
